<section class="about-banner">
    <div class="container">       
        <div class="row d-flex align-items-center justify-content-center">
            <div class="about-content col-lg-12 mt-5">
                <h1 class="text-white">
                    Work        
                </h1> 
                <p class="text-white link-nav"><a href="index.html">Home</a><span class="lnr lnr-arrow-right"></span>
                    <a href="about.html">Work</a>
                </p>
                <h4 class="site-banner">
                    Here you will know about my Work Samples, Projects and more below.
                </h4>
            </div>  
        </div>
    </div>
</section>
<section class="job-area offwhite pt-3 section-gap-bottom-90">
    <div class="container_grid">
        <div class="about">
            <div class="nav_work">
                <img src="../../assets/work/img/dp.png" alt="Nurul Hassan" class="loading dp_img" data-was-processed="true">
                <h1>Nurul Hassan</h1>
                <h2>Work Hard Everyday and Twice on Sunday 🤟</h2>
                <div class="social-media">
                    <a href="https://behance.net/nurulhassan"><img src="../../assets/work/css/behance.svg" alt="Behance" class="loading" data-was-processed="true"></a>
                    <a href="https://www.linkedin.com/in/nurulhassan/"><img src="../../assets/work/css/linkedin.svg" alt="Linkedin" class="loading" data-was-processed="true"></a>
                    <a href="https://www.facebook.com/nurulhassan2000"><img src="../../assets/work/css/facebook.svg" alt="Facebook" class="loading fa_h" data-was-processed="true"></a>
                    <a href="https://github.com/nurulhassan"><img src="../../assets/work/css/github.svg" alt="Github" class="loading" data-was-processed="true"></a>
                </div>
                <a href="../../assets/docs/offcamp.pdf"><button>Download Résumé</button></a>
                <hr>
                <a routerLink="/home" class="hvr-icon-wobble-horizontal visit">
                    <h2 ><b>Portfolio</b> <i class="fa fa-arrow-right hvr-icon"></i></h2></a>
                </div>
            </div>
            <div class="projects">
                <div class="header">
                    <h1>Projects</h1>
                    <a href="mailto:nurulhassan2000@gmail.com?Subject=Hi">Have a project for me ?</a>
                </div>
                <hr>
                <div class="list">
                    <div class="project">
                        <a href="https://www.behance.net/gallery/56565461/21-Days-of-Illustrations"><img src="../../assets/work/img/renaissance.PNG" alt="Illustrations" class="hvr-forward loading" data-was-processed="true"></a>
                        <div class="content">
                            <h4><a href="http://jecrcrenaissance.in/" target="_blank">Renaissance 2019</a></h4>
                            <h5>Becoming a better designer in 20 days</h5>
                            <p>In the starting of 2019, in an attempt to hone my illustration skills, I created an Annual Cultural Fest Renaissance Website for the College with illustration every day for Approx 3 weeks.</p>
                            <a href="http://jecrcrenaissance.in/" class="hvr-icon-wobble-horizontal check_btn">
                                Checkout Here <i class="fa fa-arrow-right hvr-icon"></i>
                            </a>
                        </div>
                    </div>
                    <div class="project">
                        <a href="https://play.google.com/store/apps/details?id=com.risl.bhamashah&hl=en"><img src="../../assets/work/img/bhamashah.png" alt="bhamashah" class="hvr-forward loading" data-was-processed="true"></a>
                        <div class="content">
                            <h4><a href="https://play.google.com/store/apps/details?id=com.risl.bhamashah&hl=en">Bhamashah App Wallet</a></h4>
                            <h5>Developing and converting the app from Ionic to Javascript for integrating it to Keypad Phone</h5>
                            <p></p>
                            <a href="https://play.google.com/store/apps/details?id=com.risl.bhamashah&hl=en" class="hvr-icon-wobble-horizontal check_btn">Checkout Here <i class="fa fa-arrow-right hvr-icon"></i></a>
                        </div>
                    </div>
                    <div class="project">
                        <a href="https://www.jecrchackathon.in/ithackathon/"><img src="../../assets/work/img/ithack.PNG" alt="Assistly" class="hvr-forward loaded" data-was-processed="true"></a>
                        <div class="content">
                            <h4><a href="https://www.jecrchackathon.in/ithackathon/">IT Hackathon</a></h4>
                            <h5>Rethinking the lengthy registration process for Hackathon</h5>
                            <p>Jecrc Hackathon is competitive coding competition in which various solutions for the problem is provided by the student developers by writing the code in various languages.</p>
                            <a href="https://www.jecrchackathon.in/ithackathon/" class="hvr-icon-wobble-horizontal check_btn">Checkout Here <i class="fa fa-arrow-right hvr-icon"></i></a>
                        </div>
                    </div>
                    <div class="project">
                        <a href="http://jecrc.in/"><img src="../../assets/work/img/jecrc.PNG" alt="Codechef" class="hvr-forward loading" data-was-processed="true"></a>
                        <div class="content">
                            <h4><a href="http://jecrc.in/">JECRC.IN</a></h4>
                            <h5>A Formal JECRC Foundation Portal following N.B.A Format</h5>
                            <p>A Formal College Website should be there accordint to National Board of Accreditation</p>
                            <a href="http://jecrc.in/" class="hvr-icon-wobble-horizontal check_btn">Checkout Here <i class="fa fa-arrow-right hvr-icon"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
        </div>
    </section>
    <script src="../../assets/work/js/jquery.js"></script>